var _g, _circle, _circle2, _circle3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpiredGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 618,
    viewBox: "0 0 618 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_1899_6630)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 309,
    r: 235,
    fill: "#5A31F4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 310,
    cy: 310,
    r: 150,
    fill: "#5A31F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 310,
    cy: 310,
    r: 122.727,
    fill: "#5A31F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.682,
    cy: 310.682,
    r: 98.8636,
    fill: "#5A31F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.207 321.435L307.968 317.677C308.937 318.026 310.036 319.347 310.777 320.092C314.193 323.506 314.193 329.128 310.777 332.542L290.866 352.44C287.45 355.853 281.824 355.853 278.408 352.44L262.108 336.15C258.692 332.736 258.692 327.114 262.108 323.7L282.014 303.807C285.43 300.393 291.056 300.393 294.472 303.807C295.217 304.552 296.54 305.65 296.889 306.614L293.128 310.372C292.159 310.023 291.06 308.702 290.319 307.957C289.187 306.825 287.3 306.825 286.167 307.957L266.261 327.846C265.128 328.978 265.128 330.864 266.261 331.996L282.561 348.285C283.694 349.417 285.58 349.417 286.713 348.285L306.619 328.392C307.752 327.26 307.752 325.374 306.619 324.242C305.879 323.502 304.552 322.4 304.207 321.435ZM298.719 268.11C298.797 267.305 299.516 266.715 300.322 266.793C301.127 266.87 301.717 267.589 301.64 268.394L300.653 278.261C300.576 279.066 299.856 279.656 299.051 279.578C298.245 279.501 297.655 278.782 297.733 277.977L298.719 268.11ZM345.216 322.576C346.026 322.628 346.642 323.325 346.591 324.134C346.539 324.944 345.841 325.559 345.031 325.508L335.128 324.888C334.318 324.836 333.702 324.139 333.754 323.329C333.805 322.52 334.503 321.904 335.313 321.956L345.216 322.576ZM337.794 340.269C338.333 340.876 338.272 341.802 337.669 342.34C337.062 342.878 336.136 342.818 335.597 342.215L329.037 334.776C328.498 334.169 328.559 333.244 329.162 332.706C329.769 332.168 330.695 332.228 331.229 332.831L337.794 340.269ZM320.034 347.54C319.982 348.35 319.285 348.965 318.475 348.914C317.665 348.862 317.049 348.165 317.101 347.355L317.721 337.458C317.773 336.649 318.47 336.033 319.28 336.085C320.09 336.137 320.706 336.834 320.654 337.643L320.034 347.54ZM280.696 274.719C280.183 274.09 280.274 273.165 280.903 272.648C281.532 272.136 282.458 272.226 282.975 272.855L289.26 280.526C289.772 281.155 289.682 282.08 289.053 282.597C288.424 283.109 287.498 283.019 286.981 282.39L280.696 274.719ZM272.632 292.128C271.826 292.05 271.236 291.332 271.314 290.527C271.391 289.722 272.111 289.132 272.916 289.209L282.79 290.195C283.595 290.273 284.185 290.992 284.108 291.796C284.03 292.602 283.311 293.191 282.505 293.114L272.632 292.128ZM292.245 326.515L307.438 311.332L303.242 307.139L288.049 322.322C286.89 323.48 286.89 325.357 288.049 326.515C289.208 327.673 291.086 327.673 292.245 326.515ZM309.075 301.59L312.043 306.726L330.653 295.99C332.074 295.172 332.557 293.359 331.738 291.939C330.92 290.518 329.106 290.036 327.685 290.854L309.075 301.59ZM314.817 292.67C314.731 291.646 313.736 290.242 313.211 289.334C312.397 287.931 312.879 286.136 314.288 285.326L338.669 271.257C340.06 270.457 341.878 270.943 342.679 272.334L354.207 292.286C355.008 293.677 354.521 295.494 353.13 296.294L328.748 310.354C327.357 311.155 325.539 310.669 324.738 309.278C324.212 308.37 323.493 306.803 322.649 306.217L318.044 308.873C318.13 309.898 319.125 311.301 319.651 312.21C322.067 316.39 327.499 317.845 331.686 315.434L356.063 301.37C360.246 298.955 361.702 293.526 359.289 289.342L347.762 269.389C345.346 265.209 339.914 263.754 335.727 266.165L311.35 280.238C307.15 282.662 305.702 288.073 308.123 292.266C308.649 293.174 309.368 294.741 310.213 295.327L314.817 292.67Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1899_6630",
    x: 0,
    y: 0,
    width: 618,
    height: 618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37,
    result: "effect1_foregroundBlur_1899_6630"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredGraphic);
export default __webpack_public_path__ + "static/media/expired-graphic.8af0c553ea13a1ddb504ce50c3b16763.svg";
export { ForwardRef as ReactComponent };